import React from "react"
import PropTypes from "prop-types"
import Icon from '../app_components/Icon'
import ProfileLanguageFlag from '../app_components/ProfileLanguageFlag'
import { semantic } from '@lexody/design-tokens'
import {
  resolveAvatarUrl,
  fallbackAvatarOnError,
  formatLocation,
  formatNameWithAge,
  formatLearningLine,
  formatSpeaksLine,
} from './connectMemberHelpers'

function CommunityMemberTile({ user, missingImg, showNew, isLive }) {
  const location = formatLocation(user.location)
  const learningLine = formatLearningLine(user.languages_users)
  const speaksLine = formatSpeaksLine(user.languages_users)
  const displayName = formatNameWithAge(user.preferred_name, user.birthday)
  const profileUrl = `/profile/${user.slug}`

  const cardClass = [
    'communityCard',
    showNew ? 'communityCard--new' : '',
    isLive ? 'communityCard--live' : '',
  ].filter(Boolean).join(' ')

  return (
    <a href={profileUrl} className={cardClass}>
      <div className="communityCard__photoWrap">
        <img
          className="communityCard__photo"
          src={resolveAvatarUrl(user.avatar_url, missingImg)}
          alt={`${user.preferred_name}'s profile photo`}
          onError={(e) => fallbackAvatarOnError(e, missingImg)}
        />
        {user.nationality_flag_html && (
          <span className="communityCard__nationality">
            <ProfileLanguageFlag flagHtml={user.nationality_flag_html} size={28} />
          </span>
        )}
        {showNew && (
          <span className="communityCard__badge communityCard__badge--new">New</span>
        )}
        {isLive && (
          <span className="communityCard__badge communityCard__badge--live" aria-label="Online now" />
        )}
      </div>

      <div className="communityCard__body">
        <p className="communityCard__name">{displayName}</p>
        <div className="communityCard__languages">
          {learningLine && (
            <p className="communityCard__learning">{learningLine}</p>
          )}
          {speaksLine && (
            <p className="communityCard__speaks">{speaksLine}</p>
          )}
        </div>
        {location && (
          <p className="communityCard__location">
            <Icon name="map-marker" size={12} color={semantic.greyscale.text.subtitle} />
            <span>{location}</span>
          </p>
        )}
      </div>
    </a>
  )
}

CommunityMemberTile.propTypes = {
  user: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    avatar_url: PropTypes.string,
    preferred_name: PropTypes.string,
    birthday: PropTypes.string,
    location: PropTypes.string,
    nationality_flag_html: PropTypes.string,
    languages_users: PropTypes.array,
  }).isRequired,
  missingImg: PropTypes.string.isRequired,
  showNew: PropTypes.bool,
  isLive: PropTypes.bool,
}

CommunityMemberTile.defaultProps = {
  showNew: false,
  isLive: false,
}

export default CommunityMemberTile
